import { useContext, useMemo } from 'react';

import EChart from '../../component/chart/echarts/EChart';
import { TimeRangeContext } from '../../context/TimeRangeContext';
import { getTimeZone } from '../../helpers/utils';
import BackupHistoryItem from '../../types/backup/BackupHistoryItem';
import BackupSummary from '../../types/backup/BackupSummary';
import BackupAlert from '../../types/backup/BackupAlert';
import { BackupChartMetric } from './backupUtils';
import { buildBackupHistoryOption } from './backupHistoryOption';
import { backupAlertPlotLines } from './backupAlertPlotLines';

interface Props {
    items: BackupHistoryItem[];
    alerts: BackupAlert[];
    days: number;
    metric: BackupChartMetric;
    // For the point-in-time restore window of the current chain.
    row: BackupSummary;
}

// See buildBackupHistoryOption.
function BackupHistoryChart(props: Props) {
    const { timeRange } = useContext(TimeRangeContext);
    // Now moves on whenever the items reload.
    const { option, plotLines } = useMemo(() => {
        const now = Date.now();
        const plotLines = backupAlertPlotLines(props.alerts, now - props.days * 86400000, now);
        return {
            plotLines,
            option: buildBackupHistoryOption({
                items: props.items,
                days: props.days,
                metric: props.metric,
                row: props.row,
                timezone: timeRange.timezone || getTimeZone(),
                now,
                plotLines,
            }),
        };
    }, [props.items, props.alerts, props.days, props.metric, props.row, timeRange.timezone]);

    // Fixed thin bars: each is one backup at its start time, not a time bucket.
    return <EChart option={option} plotLines={plotLines} height={220} fixedBarWidth/>;
}

export default BackupHistoryChart;
